import { Injectable, ComponentFactoryResolver, Type, ViewContainerRef, ComponentRef } from '@angular/core';
import { HorizontalBarByDimensionComponent } from '../panel-elements/horizontal-bar-by-dimension/horizontal-bar-by-dimension.component';
import { CombinedDataTableComponent } from '../../dataTable/combinedDataTable.component';
import { ElementComponent, PanelComponent } from '../../models/report-view.models';
import * as PanelElements from '../panel-elements/panel-elements-index';
import { FullWidthDataPanelComponent } from './full-width-data-panel/full-width-data-panel.component';
import { TextPanelComponent } from './text-panel/text-panel.component';
import { GhostPanelFullWidthComponent } from './ghost-panel-full-width/ghost-panel-full-width.component';
import { OverviewFullWidthPanelComponent } from './overview-full-width-panel/overview-full-width-panel.component';
import { GhostPanelComponent } from './ghost-panel/ghost-panel.component';
import { IndexedVisualizationPanelComponent } from './indexed-visualization-panel/indexed-visualization-panel.component';
import { TransactionDetailsDataTableComponent } from '../panel-elements/transaction-details-data-table/transaction-details-data-table.component';

@Injectable()
export class PanelElementResolverService {

    constructor() { }

    private readonly panelMap: { [key: string]: Type<PanelComponent> } = {
        'data-panel': FullWidthDataPanelComponent,
        'overview-full-width-panel': OverviewFullWidthPanelComponent,
        'ghost-panel-full-width': GhostPanelFullWidthComponent,
        'ghost-panel': GhostPanelComponent,
        'full-width-data-panel': FullWidthDataPanelComponent,
        'indexed-visualization-panel': IndexedVisualizationPanelComponent,
        'text-panel': TextPanelComponent
      };      
    
    private readonly elementMap: { [key: string]: Type<ElementComponent> } = {
        'billboard-benchmark': PanelElements.BillboardBenchmarkComponent,
        'column-chart': PanelElements.ColumnChartComponent,
        'hierarchy-data-table': PanelElements.HierarchyDataTableV5Component,
        'horizontal-bar-by-dimension': PanelElements.HorizontalBarByDimensionComponent,
        'horizontal-funnel': PanelElements.HorizontalFunnelV2Component,
        'kpi-bar-chart': PanelElements.KpiBarChartComponent,
        'kpi-dual-metric-detailed': PanelElements.KpiDualMetricDetailedComponent,
        'kpi-line-comparison-chart': PanelElements.KpiLineComparisonChartComponent,
        'kpi-pacing-gauge': PanelElements.KpiPacingGaugeComponent,
        'kpi-pacing-metrics': PanelElements.KpiPacingMetricsComponent,
        'kpi-metric': PanelElements.KpiMetricComponent,
        'kpi-metric-detailed': PanelElements.KpiMetricDetailedComponent,
        'kpi-multi-line-chart': PanelElements.KpiMultiLineChartComponent,
        'kpi-pie-chart': PanelElements.KpiPieChartComponent,
        'kpi-semi-circle-donut': PanelElements.KpiSemiCircleDonutComponent,
        'kpi-sheet': PanelElements.KpiSheetComponent,
        'kpi-spark-area-fill': PanelElements.KpiSparkAreaFillComponent,
        'line-chart-with-forecast': PanelElements.LineChartWithForecastComponent,
        'scatter-plot': PanelElements.ScatterPlotComponent,
        'scorecard-billboard': PanelElements.ScorecardBillboardElementComponent,
        'scorecard-billboard-repeater': PanelElements.ScorecardBillboardElementRepeaterComponent,
        'stacked-bar-chart-percent': PanelElements.StackedBarChartPercentComponent,
        'stacked-column-chart': PanelElements.StackedColumnChartComponent,
        'stacked-dual-metric': PanelElements.StackedDualMetricComponent,
        'stacked-two-kpi-metric': PanelElements.StackedTwoKpiMetricComponent,
        'tri-metric': PanelElements.TriMetricComponent,
        'transaction-details-data-table': TransactionDetailsDataTableComponent,
        'kpi-pie-chart-stacked-dual-metric': PanelElements.KpiPieChartStackedDualMetricComponent,
        'kpi-vertical-funnel': PanelElements.KpiVerticalFunnelComponent,
        'ranked-horizontal-bar-chart': PanelElements.RankedHorizontalBarChartComponent,
        'fixed-placement-horizontal-bar-chart': PanelElements.FixedPlacementHorizontalBarComponent,
      };

      resolvePanelComponent(containerRef: ViewContainerRef, panelType: string): ComponentRef<PanelComponent> {
        const component = this.panelMap[panelType];

        if (!component)
            throw new Error(`Panel type ${panelType} not found`);

        return containerRef.createComponent(component);
      }

      resolveElementComponent(containerRef: ViewContainerRef, elementType: string): ComponentRef<ElementComponent> {
        const component = this.elementMap[elementType];

        if (!component)
            throw new Error(`Element type ${elementType} not found`);

        return containerRef.createComponent(component);
      }
}
